<template>
  <v-row>
    <v-col cols="6" v-if="$can('projects.members.manage')">
      <v-card flat outlined>
        <v-card-title>Assign existing users to project</v-card-title>

        <v-card-text>
          <project-assign-members-form></project-assign-members-form>
        </v-card-text>
      </v-card>

      <v-card outlined class="mt-6" v-if="$can('users.invite')">
        <v-card-title>Invite new users to project</v-card-title>

        <v-card-text>
          <user-invite-form :invite-to-project="project.id"></user-invite-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="6" v-if="$can('projects.members')">
      <project-members-list></project-members-list>
    </v-col>
    <v-col cols="6"> </v-col>
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProjectAssignMembersForm from '@/components/projects/ProjectAssignMembersForm'
import ProjectMembersList from '@/components/projects/ProjectMembersList'
import UserInviteForm from '@/components/users/UserInviteForm'

export default {
  name: 'ProjectMembers',
  components: {
    ProjectAssignMembersForm,
    ProjectMembersList,
    UserInviteForm
  },
  computed: {
    ...mapState('projects', ['project'])
  },
  methods: {
    ...mapActions('users', ['fetchUsers'])
  },
  created() {
    this.fetchUsers()
  }
}
</script>
